import axiosClient from "./axiosClient";
import { unwrapApiResponse } from "../utils/apiResponse";

export const getSectionsByPage = async (pageId) => {
  const response = await axiosClient.get(`/api/admin/pages/${pageId}/sections`);
  return unwrapApiResponse(response);
};

export const createSection = async (pageId, payload) => {
  const response = await axiosClient.post(`/api/admin/pages/${pageId}/sections`, payload);
  return unwrapApiResponse(response);
};

export const updateSection = async (sectionId, payload) => {
  const response = await axiosClient.put(`/api/admin/sections/${sectionId}`, payload);
  return unwrapApiResponse(response);
};

export const deleteSection = async (sectionId) => {
  const response = await axiosClient.delete(`/api/admin/sections/${sectionId}`);
  return unwrapApiResponse(response);
};
